//# sourceMappingURL=label.mjs.map
/// <reference types="./label.d.mts" />
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $justin from "../../../justin/justin.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $colors from "../../ds/colors.mjs";
import * as $cypress from "../../ds/cypress.mjs";
import * as $text from "../../ds/typography/text.mjs";
import { toList, prepend as listPrepend, CustomType as $CustomType } from "../../gleam.mjs";

class StatusContent extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class ContentContent extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class IconContent extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class OnClickContent extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class SizeContent extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class IconPosition extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class LinkContent extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Capitalize extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Truncate extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Success extends $CustomType {}
export const Status$Success = () => new Success();
export const Status$isSuccess = (value) => value instanceof Success;

export class Error extends $CustomType {}
export const Status$Error = () => new Error();
export const Status$isError = (value) => value instanceof Error;

export class Current extends $CustomType {}
export const Status$Current = () => new Current();
export const Status$isCurrent = (value) => value instanceof Current;

export class Neutral extends $CustomType {}
export const Status$Neutral = () => new Neutral();
export const Status$isNeutral = (value) => value instanceof Neutral;

export class NeutralLight extends $CustomType {}
export const Status$NeutralLight = () => new NeutralLight();
export const Status$isNeutralLight = (value) => value instanceof NeutralLight;

export class Medium extends $CustomType {}
export const Size$Medium = () => new Medium();
export const Size$isMedium = (value) => value instanceof Medium;

export class Large extends $CustomType {}
export const Size$Large = () => new Large();
export const Size$isLarge = (value) => value instanceof Large;

export class Small extends $CustomType {}
export const Size$Small = () => new Small();
export const Size$isSmall = (value) => value instanceof Small;

export class Left extends $CustomType {}
export const Position$Left = () => new Left();
export const Position$isLeft = (value) => value instanceof Left;

export class Right extends $CustomType {}
export const Position$Right = () => new Right();
export const Position$isRight = (value) => value instanceof Right;

class Attr extends $CustomType {
  constructor(status, content, icon, on_click, size, icon_position, link, capitalize, truncate) {
    super();
    this.status = status;
    this.content = content;
    this.icon = icon;
    this.on_click = on_click;
    this.size = size;
    this.icon_position = icon_position;
    this.link = link;
    this.capitalize = capitalize;
    this.truncate = truncate;
  }
}

function large_class() {
  return $css.class$(
    toList([
      $css.compose($text.lg($text.medium)),
      $css.padding_("8px 24px"),
      $css.gap(px(10)),
    ]),
  );
}

function small_class() {
  return $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.padding_("2px 6px"),
      $css.gap(px(5)),
    ]),
  );
}

function label_class() {
  return $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.padding_("4px 12px"),
      $css.border_radius(px(4)),
      $css.text_align("center"),
      $css.white_space("nowrap"),
    ]),
  );
}

/**
 * Content of a truncated label. The ellipsis lives on that inner span, because
 * `text-overflow` has no effect on the label itself: it is a flex container,
 * so its text child is an anonymous flex item.
 * 
 * @ignore
 */
function truncated_content(content) {
  let _pipe = $css.class$(
    toList([
      $css.overflow("hidden"),
      $css.text_overflow("ellipsis"),
      $css.white_space("nowrap"),
      $css.min_width(px(0)),
    ]),
  );
  return $h.span(_pipe, toList([]), toList([$h.text(content)]));
}

function clickable_class(color) {
  return $css.class$(
    toList([
      $css.cursor("pointer"),
      $css.border("1px solid transparent"),
      $css.transition("border-color .3s"),
      $css.hover(toList([$css.property("border-color", color)])),
    ]),
  );
}

function status_to_colors(status) {
  if (status instanceof Success) {
    return [$colors.light.success_100, $colors.light.success_800];
  } else if (status instanceof Error) {
    return [$colors.light.error_100, $colors.light.error_800];
  } else if (status instanceof Current) {
    return [$colors.light.blue_100, $colors.light.blue_800];
  } else if (status instanceof Neutral) {
    return [$colors.light.grey_200, $colors.light.grey_800];
  } else {
    return [$colors.light.grey_100, $colors.light.grey_800];
  }
}

function to_attrs(attributes) {
  let attrs = new Attr(
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
  );
  return $list.fold(
    attributes,
    attrs,
    (attrs, attr) => {
      if (attr instanceof StatusContent) {
        let s = attr[0];
        return new Attr(
          new Some(s),
          attrs.content,
          attrs.icon,
          attrs.on_click,
          attrs.size,
          attrs.icon_position,
          attrs.link,
          attrs.capitalize,
          attrs.truncate,
        );
      } else if (attr instanceof ContentContent) {
        let c = attr[0];
        return new Attr(
          attrs.status,
          new Some(c),
          attrs.icon,
          attrs.on_click,
          attrs.size,
          attrs.icon_position,
          attrs.link,
          attrs.capitalize,
          attrs.truncate,
        );
      } else if (attr instanceof IconContent) {
        let i = attr[0];
        return new Attr(
          attrs.status,
          attrs.content,
          new Some(i),
          attrs.on_click,
          attrs.size,
          attrs.icon_position,
          attrs.link,
          attrs.capitalize,
          attrs.truncate,
        );
      } else if (attr instanceof OnClickContent) {
        let o = attr[0];
        return new Attr(
          attrs.status,
          attrs.content,
          attrs.icon,
          new Some(o),
          attrs.size,
          attrs.icon_position,
          attrs.link,
          attrs.capitalize,
          attrs.truncate,
        );
      } else if (attr instanceof SizeContent) {
        let s = attr[0];
        return new Attr(
          attrs.status,
          attrs.content,
          attrs.icon,
          attrs.on_click,
          new Some(s),
          attrs.icon_position,
          attrs.link,
          attrs.capitalize,
          attrs.truncate,
        );
      } else if (attr instanceof IconPosition) {
        let p = attr[0];
        return new Attr(
          attrs.status,
          attrs.content,
          attrs.icon,
          attrs.on_click,
          attrs.size,
          new Some(p),
          attrs.link,
          attrs.capitalize,
          attrs.truncate,
        );
      } else if (attr instanceof LinkContent) {
        let l = attr[0];
        return new Attr(
          attrs.status,
          attrs.content,
          attrs.icon,
          attrs.on_click,
          attrs.size,
          attrs.icon_position,
          new Some(l),
          attrs.capitalize,
          attrs.truncate,
        );
      } else if (attr instanceof Capitalize) {
        let c = attr[0];
        return new Attr(
          attrs.status,
          attrs.content,
          attrs.icon,
          attrs.on_click,
          attrs.size,
          attrs.icon_position,
          attrs.link,
          new Some(c),
          attrs.truncate,
        );
      } else {
        let w = attr[0];
        return new Attr(
          attrs.status,
          attrs.content,
          attrs.icon,
          attrs.on_click,
          attrs.size,
          attrs.icon_position,
          attrs.link,
          attrs.capitalize,
          new Some(w),
        );
      }
    },
  );
}

export function label(attributes) {
  let attrs = to_attrs(attributes);
  let status$1 = $option.unwrap(attrs.status, new Neutral());
  let $ = status_to_colors(status$1);
  let background = $[0];
  let color = $[1];
  let icon$1 = $option.lazy_unwrap(attrs.icon, $h.none);
  let content$1 = $option.unwrap(attrs.content, $string.inspect(status$1));
  let size$1 = $option.unwrap(attrs.size, new Medium());
  let capitalize$1 = $option.unwrap(attrs.capitalize, true);
  let _block;
  let $2 = attrs.link;
  let $3 = attrs.on_click;
  if ($2 instanceof Some) {
    let url = $2[0];
    _block = [
      $h.a,
      $css.none(),
      toList([
        $a.href(url),
        $a.target("_blank"),
        $a.attribute("rel", "noopener noreferrer"),
      ]),
    ];
  } else if ($3 instanceof Some) {
    let o = $3[0];
    _block = [
      $h.button,
      $css.compose(clickable_class(color)),
      toList([$e.on_click((_) => { return o(); }), $a.type_("button")]),
    ];
  } else {
    _block = [$h.div, $css.none(), toList([$a.none()])];
  }
  let $1 = _block;
  let node = $1[0];
  let click_class = $1[1];
  let handler = $1[2];
  let cy = $cypress.data($justin.kebab_case(content$1) + "-dropdown-choice");
  let _block$1;
  let $5 = attrs.truncate;
  if ($5 instanceof Some) {
    let max_width = $5[0];
    _block$1 = [
      $css.max_width(px(max_width)),
      $a.title(content$1),
      truncated_content(content$1),
    ];
  } else {
    _block$1 = [$css.none(), $a.none(), $h.text(content$1)];
  }
  let $4 = _block$1;
  let truncate_class = $4[0];
  let title = $4[1];
  let content_element = $4[2];
  let _pipe = $css.class$(
    toList([
      $css.compose(label_class()),
      $css.background(background),
      $css.color(color),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.gap(px(5)),
      $css.border("1px solid transparent"),
      $css.selector(
        ":has( .delete-icon:hover)",
        toList([
          $css.background_color($colors.palette.grey_100),
          $css.color($colors.palette.grey_600),
          $css.text_decoration("line-through 1px solid"),
        ]),
      ),
      click_class,
      truncate_class,
      (() => {
        if (capitalize$1) {
          return $css.text_transform("capitalize");
        } else {
          return $css.none();
        }
      })(),
      (() => {
        if (size$1 instanceof Medium) {
          return $css.none();
        } else if (size$1 instanceof Large) {
          return $css.compose(large_class());
        } else {
          return $css.compose(small_class());
        }
      })(),
    ]),
  );
  return node(
    _pipe,
    listPrepend(cy, listPrepend(title, handler)),
    (() => {
      let $6 = attrs.icon_position;
      if ($6 instanceof Some) {
        let $7 = $6[0];
        if ($7 instanceof Left) {
          return toList([icon$1, content_element]);
        } else {
          return toList([content_element, icon$1]);
        }
      } else {
        return toList([icon$1, content_element]);
      }
    })(),
  );
}

/**
 * Set status on label. You can use `success`, `error`, `current` or `neutral`
 * to set a status directly. That function is used for dynamically choosing a
 * status.
 *
 * > Always use one of the specialised version if able.
 */
export function status(status) {
  return new StatusContent(status);
}

/**
 * Specialised version of `status`. Equivalent of `label.status(label.Success)`.
 */
export function success() {
  return new StatusContent(new Success());
}

/**
 * Specialised version of `status`. Equivalent of `label.status(label.Error)`.
 */
export function error() {
  return new StatusContent(new Error());
}

/**
 * Specialised version of `status`. Equivalent of `label.status(label.Current)`.
 */
export function current() {
  return new StatusContent(new Current());
}

/**
 * Specialised version of `status`. Equivalent of `label.status(label.Neutral)`.
 */
export function neutral() {
  return new StatusContent(new Neutral());
}

/**
 * Specialised version of `status`. Equivalent of `label.status(label.Neutral)`.
 */
export function neutral_light() {
  return new StatusContent(new NeutralLight());
}

/**
 * Set size of label. You can use `medium` or `large` to set the size directly.
 * That function is used for dynamically choosing a size.
 *
 * > Always use one of the specialised version if able.
 */
export function size(size) {
  return new SizeContent(size);
}

/**
 * Specialised version of `size`. Equivalent of `label.size(label.Small)`.
 */
export function small() {
  return new SizeContent(new Small());
}

/**
 * Specialised version of `size`. Equivalent of `label.size(label.Medium)`.
 */
export function medium() {
  return new SizeContent(new Medium());
}

/**
 * Specialised version of `size`. Equivalent of `label.size(label.Large)`.
 */
export function large() {
  return new SizeContent(new Large());
}

/**
 * Set content of the label.
 */
export function content(content) {
  return new ContentContent(content);
}

/**
 * Set icon of the label. It should be the icon directly rendered.
 */
export function icon(icon) {
  return new IconContent(icon);
}

/**
 * Set icon position of the label on the right.
 */
export function icon_right() {
  return new IconPosition(new Right());
}

/**
 * Set icon position of the label on the left.
 */
export function icon_left() {
  return new IconPosition(new Left());
}

/**
 * Set `on_click` handler on the label. Label with an `on_click` handler will
 * be rendered as a `<button>`, otherwise it will be rendered as a `<div>`.
 */
export function on_click(on_click) {
  return new OnClickContent(on_click);
}

/**
 * Set `link` value on the label. Label with an `link` valie will
 * be rendered as a `<a>`, otherwise it will be rendered as a `<div>` or <button>.
 */
export function link(link) {
  return new LinkContent(link);
}

export function capitalize(val) {
  return new Capitalize(val);
}

/**
 * Cap the label width to `max_width` pixels, and cut the content with an
 * ellipsis when it does not fit. The full content stays reachable as a native
 * tooltip on hover. Use it for labels built from user data, which can be
 * arbitrarily long — a label is `nowrap` by default, so an unbounded content
 * widens every ancestor.
 */
export function truncate(max_width) {
  return new Truncate(max_width);
}
